// src/api.js
const API_URL = 'https://api.zolertrading.com';

export const api = {
  get: (endpoint) => fetch(`${API_URL}${endpoint}`).then(r => r.json()),
  post: (endpoint, data) => fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }).then(r => r.json()),
  patch: (endpoint, data) => fetch(`${API_URL}${endpoint}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }).then(r => r.json()),
  delete: (endpoint) => fetch(`${API_URL}${endpoint}`, {
    method: 'DELETE'
  }).then(r => r.json()),
};

export default API_URL;